import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import apiConfig from '@/config/api.config'

Vue.use(Vuex)

// 设置 axios baseURL - 从统一配置读取（与 main.js 保持一致）
axios.defaults.baseURL = apiConfig.baseURL

// 从 localStorage 恢复用户信息
const savedUser = localStorage.getItem('user')
const initialUser = savedUser ? JSON.parse(savedUser) : null

const store = new Vuex.Store({
  // 保存状态
  state: {
    HomeData: null,
    token: null,
    isAddOrder: false,
    orderlist: [],
    user: initialUser, // 当前用户信息（从 localStorage 恢复）
    cartCount: 0 // 购物车商品类别数（全局，CartFloatEntry 角标 + Cart.vue 同步）
  },
  mutations: {
    // 方法
    getHomeData (state) {
      state.HomeData = this.orderlist.length
    },
    switchAdd () {
      if (this.isAddOrder === false) {
        this.isAddOrder = true
      } else {
        this.isAddOrder = false
      }
    },
    setUser (state, userData) {
      // 更新 store
      state.user = userData
      // 同步到 localStorage（保持一致性）
      if (userData) {
        localStorage.setItem('user', JSON.stringify(userData))
      } else {
        localStorage.removeItem('user')
      }
    },
    clearUser (state) {
      state.user = null
      // 登出连清购物车角标：防"上个账号的角标残留给下一个账号"（换号混合状态，spec C/I）
      state.cartCount = 0
      localStorage.removeItem('user')
    },
    setCartCount (state, count) {
      state.cartCount = count || 0
    }
  },
  actions: {
    async fetchUser ({ commit }) {
      try {
        const token = localStorage.getItem('token')
        if (!token) return

        const response = await axios.get('/user/info', {
          headers: { Authorization: `Bearer ${token}` }
        })

        if (response.data.code === 200 && response.data.data) {
          commit('setUser', response.data.data)
          return response.data.data
        }
      } catch (err) {
        console.error('获取用户信息失败:', err)
      }
    },
    // 统一刷新用户信息（从服务端获取最新状态）
    async refreshUser ({ commit, state }) {
      if (!state.user?.id) return null
      try {
        const response = await axios.get('/user/info')
        if (response.data.code === 200 && response.data.data) {
          commit('setUser', response.data.data)
          return response.data.data
        }
      } catch (err) {
        console.error('刷新用户信息失败:', err)
      }
      return null
    },
    // 统一刷新购物车角标数：拉取真实购物车类别数 → commit。
    // 加入货篮/删除/清空后各页面 dispatch 此 action，CartFloatEntry 角标即时刷新，不必等路由切换。
    async refreshCartCount ({ commit }) {
      const token = localStorage.getItem('token')
      if (!token) { commit('setCartCount', 0); return }
      try {
        const res = await axios.get('/cart', { headers: { Authorization: `Bearer ${token}` } })
        if (res.data.code === 200) commit('setCartCount', (res.data.data || []).length)
      } catch (e) {
        // 静默：拉取失败不抹角标，避免误清
      }
    }
  },
  getters: {
    // 归一化：兼容登录后的嵌套结构 { token, user: { id, role } } 与 /user/info 的扁平结构 { id, role }
    _normUser: state => {
      const u = state.user
      if (!u) return null
      // 扁平格式：{ id, role } → 直接返回
      if (u.id && u.role) return u
      // 嵌套格式：{ token, user: { id, role } } → 返回内层
      if (u.user && u.user.id) return u.user
      return u
    },
    currentUserId: (state, getters) => getters._normUser?.id,
    currentUserRole: (state, getters) => getters._normUser?.role || 'user',
    isSuperAdmin: (state, getters) => getters._normUser?.role === 'super_admin',
    isAdmin: (state, getters) => getters._normUser?.role === 'super_admin' || getters._normUser?.role === 'admin',
    isCourier: (state, getters) => getters._normUser?.role === 'courier',
    isOperator: (state, getters) => getters._normUser?.role === 'operator',
    isUser: (state, getters) => getters._normUser?.role === 'user',
    userRole: (state, getters) => getters._normUser?.role || 'user',
    userStatus: (state, getters) => getters._normUser?.status || 'active',
    isActiveUser: (state, getters) => getters._normUser?.status === 'active',
    currentUser: (state, getters) => getters._normUser
  },
  modules: {
  }
})

export default store
